import React, { useState,useEffect,useRef } from 'react';
import styles from './add-edit-product.scss';
import withRipple from 'jd-library/withRipple';
import JdRepresentativeProfile from './jdRepresentativeProfile';

const JdRepresentativeHeader = props => {
  const isCorrector = props.session.user.loggedUser?.subType === "CORRECTOR"    
  const correctorDetails = isCorrector && props?.showAuditData?.dispositionValue &&  props?.showAuditData?.dispositionValue?.length && JSON.parse(props.showAuditData.dispositionValue[0]);
  let newStr = '';
  if (isCorrector){
    for (var key in correctorDetails) {
        if(key.toString().toLowerCase() != 'others')
            newStr += (newStr!='' ? ', ' : '') + key.toString();
            
        if (correctorDetails.hasOwnProperty(key) && Array.isArray(correctorDetails[key]) && correctorDetails[key].length > 0) {
            newStr += '('+correctorDetails[key].join()+')';    
        }
    }
  }

    const [showJdRepresentative,toggleJdRepresentative] = useState(false);
    let DisplayUserDetails = [];
	let showUserDetails = showJdRepresentative ? {maxHeight:'300px'} : null;
    let paginationIcon = showJdRepresentative ? 'icon-pagination-up' : 'icon-pagination-down';
    const isJDEmp = props.contractorData?.conType && props.contractorData?.conType.toUpperCase()==='JDEMPLOYEE';
    const isOnBoarding = props.contractorData?.conType && props.contractorData?.conType.toUpperCase()==='ONBOARDING_EMP'
    const isContractorDetail = props.contractorData.conName && props.contractorData.conMob;
    const isAuditor = props.session.user.loggedUser.userType == 'AUDITOR'    
    const toggleJdRepresentativeDetails = () =>{
		toggleJdRepresentative(!showJdRepresentative);
    }
        let userDetailsData = [];
        if(isContractorDetail) {
            userDetailsData = [
                {
                    text: props.contractorData.label + ' '+props.contractorData.conName,
                    iconclass:'icon-profile'
                },
                {
                    text:props.contractorData.conMob,
                    iconclass:'icon-HDRcall'
                }
            ];
        } else {
            userDetailsData = [
                {
                    text:props.userData.employeeName,
                    iconclass:'icon-profile'
                },
                {
                    text:props.userData.employeeMobileList[0],
                    iconclass:'icon-HDRcall'
                },
                {
                    text:props.userData.employeeEmailList[0],
                    iconclass:'icon-mailLg'
                },
                {
                    text:props.userData.rid,
                    iconclass:'icon-EmploeeID'
                }
            ];
        }
        for(let i =0;i<userDetailsData.length;i++){
            DisplayUserDetails.push(
                <div className={styles['user-details-list']}>
                    <span className={styles['user-details-icon']+" "+userDetailsData[i].iconclass}></span>
                    {userDetailsData[i].text}
                </div>
            )
        }

    return (
      <>
        <div className={styles["header-holder"]}>
          <div className={styles["data-holder"]}>
            <JdRepresentativeProfile
              session={props.session}
              updateAuditDocModal={props.updateAuditDocModal}
              auditBtnArray={props.auditBtnArray}
              showToastMessage={props.showToastMessage}
              isAddProduct={props.isAddProduct}
              showTotalCount={props.showTotalCount}
              totalCount={props.totalCount}
              AuditWebsiteBtn={props.AuditWebsiteBtn}
              belongsTo={props.belongsTo}
              type={props.type}
              dataSource={props.dataSource}
              contractorSourceList={props.contractorSourceList}
              isContractorSourcev1={props.isContractorSourcev1}
              websiteLink={props.websiteLink}
              ownerConnectedMobile={props.ownerConnectedMobile}
              isShowConnectedNumberButton={
                props.ownerConnectedMobile ? true : false
              }
              isContractorSoruceLbl={isOnBoarding ? "Onboarding" : "Contractor"}
            />
          </div>
          {(props.userData.employeeName || isContractorDetail) &&
          !props.isAddProduct ? (
            <div className={styles["user-details-holder"]}>
              {!isCorrector && (
                <JdRepresentativeTab
                  toggleJdRepresentativeDetails={toggleJdRepresentativeDetails}
                  type={
                    isOnBoarding
                      ? "onboarding"
                      : isContractorDetail && !isJDEmp
                      ? "contractor"
                      : props.type
                  }
                  paginationIcon={paginationIcon}
                />
              )}
              {isCorrector && props.showAuditData && props.showAuditData?.auditDisposition == 'MAJOR_ERROR' && (
                <div className={`${styles["corrected-product-container"]} ${styles["correct-pending"]} ${styles["marginLR15"]}`}>
                <div className={`${styles["correcting-text"]} ${styles["warning-status"]}`}>
                  <div>
                    <div className={styles["correcting-status"]}>
                      <strong>Audit Details</strong>
                    </div>
                    <div className={`${styles["correction-message"]}`}>
                      <strong>Major Error:  {props?.auditDisposition || ''} </strong> 
                      {newStr || ''}
                      <br/>
                      <strong>Comments:</strong> {props.showAuditData.comment || 'None'}
                    </div>
                  </div>
                </div>
              </div>
              )}
              <div className={styles["user-details-data"]}
                style={showUserDetails}
              >
                {DisplayUserDetails}
                <div className={styles["user-details-data-dummy"]}></div>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
};

const JdRepresentativeTab = withRipple(props => {
	return (
		<div className={styles['user-details-tab']+" "+props.rippleClass} onClick={props.toggleJdRepresentativeDetails}{...props.rippleHandler}>
                <div className={styles['user-details-tab-text']}>{props.type == 'onboarding' ? 'Onboarding Employee Details' : ((props.type == 'contractor' || props.type == 'contractorv2' || props.type == 'contractorv3') ? 'Contractor Details' : 'Justdial Representative Details')}</div>
            <span className={styles['icon-pagination-down-audit']+" "+props.paginationIcon} ></span>
            {props.renderRipple()}
            </div>
	);
});

export default JdRepresentativeHeader;